import { tablet } from "@/App/breakpoints";

import "./style.css";

export default class SpecialismsList {
  static selector = ".specialisms-list";

  constructor(block) {
    this.block = block;

    this.switch = this.block.querySelector(".switch-grid");
    this.switchCaption = this.block.querySelector(
      ".specialisms-list__head-switch-caption"
    );
    this.specialismsContainer = this.block.querySelector(
      ".specialisms-list__grid"
    );
  }

  handleSwitchChange = e => {
    const { checked } = e.currentTarget;

    if (checked) {
      this.specialismsContainer?.classList.add("grid-view");
      this.specialismsContainer?.classList.remove("list-view");

      if (this.switchCaption) {
        this.switchCaption.innerText = "SWITCH TO LIST VIEW";
      }
    } else {
      this.specialismsContainer?.classList.add("list-view");
      this.specialismsContainer?.classList.remove("grid-view");

      if (this.switchCaption) {
        this.switchCaption.innerText = "SWITCH TO GRID VIEW";
      }
    }
  };

  onReady = () => {
    this.switch?.addEventListener("change", this.handleSwitchChange);
  };

  onResize = () => {
    if (this.switch.checked && window.innerWidth < tablet) {
      this.switch.checked = false;
      this.handleSwitchChange({ currentTarget: this.switch });
    }
  };

  onDestroy = () => {
    this.switch?.removeEventListener("change", this.handleSwitchChange);
  };
}
